function SkeletonRow({ widths }: { widths: [string, string, string] }) {
  return (
    <div className="flex items-center gap-4 px-4 py-3 border-b border-border">
      <div className="skeleton w-6 h-3 shrink-0" />
      <div className="skeleton w-6 h-6 shrink-0" />
      <div className="min-w-0 flex-1 flex items-center gap-3">
        <div className={`skeleton h-3.5 ${widths[0]}`} />
        <div className={`skeleton h-3 ${widths[1]} hidden lg:block`} />
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <div className="skeleton w-10 h-3 hidden sm:block" />
        <div className={`skeleton ${widths[2]} h-3`} />
        <div className="skeleton w-10 h-3 hidden sm:block" />
        <div className="skeleton w-12 h-3 hidden md:block" />
      </div>
    </div>
  );
}

const ROW_VARIANTS: [string, string, string][] = [
  ["w-32", "w-48", "w-14"],
  ["w-40", "w-36", "w-12"],
  ["w-28", "w-52", "w-16"],
  ["w-36", "w-40", "w-10"],
  ["w-44", "w-32", "w-14"],
  ["w-24", "w-56", "w-12"],
  ["w-38", "w-44", "w-16"],
  ["w-30", "w-48", "w-10"],
];

export function SearchSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="border-t border-border">
      {/* Header */}
      <div className="flex items-center gap-4 px-4 py-2 border-b border-border">
        <div className="skeleton w-4 h-2.5 shrink-0" />
        <div className="skeleton w-4 h-2.5 shrink-0" />
        <div className="skeleton w-12 h-2.5 flex-none" />
        <div className="flex-1" />
        <div className="flex items-center gap-4 shrink-0">
          <div className="skeleton w-8 h-2.5 hidden sm:block" />
          <div className="skeleton w-10 h-2.5" />
          <div className="skeleton w-10 h-2.5 hidden sm:block" />
          <div className="skeleton w-14 h-2.5 hidden md:block" />
        </div>
      </div>
      {Array.from({ length: rows }, (_, i) => (
        <SkeletonRow key={i} widths={ROW_VARIANTS[i % ROW_VARIANTS.length]!} />
      ))}
    </div>
  );
}
